import { render, staticRenderFns } from "./Technics.vue?vue&type=template&id=0d001111&"
import script from "./Technics.vue?vue&type=script&lang=js&"
export * from "./Technics.vue?vue&type=script&lang=js&"
import style0 from "./Technics.vue?vue&type=style&index=0&id=0d001111&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports